<template>
    <Logo
        class="logo__container--map"
        :show_custom="!is_pub"
        :custom_logo="custom_logo"
        color="White"
        :cwa_logo_src="`/static/UIUX/images/header/${logo_file_name}_White_web@2x.png`"
    />
</template>

<script>
    import {
        get_short_term_precp_datetime_ajax,
        get_short_term_precp_ajax,
    } from "../utils/pro/short_term_precp_ajax";
    import { UNITS_PRO } from "../config/config"
    import { mapGetters, mapMutations, mapState } from "vuex";

    import Logo from "./logo.vue"

    export default {
        name: 'Navbar',

        components: { Logo },

        data() {
            return {
                is_show_short_term_precp_hint: false,
                short_term_precp_interval: '',
                newest_precp_datetime: '',
            };
        },
        
        computed: {
            ...mapState([
                'client_name',
                'user',
                'is_short_term_precp_occur'
            ]),

            ...mapGetters([
                'is_pub',
                'logo_file_name',
                'is_mobile_width',
            ]),

            is_activate_short_term_precp_feature() {
                return UNITS_PRO.includes(this.client_name)
            },

            custom_logo() {
                return this.is_mobile_width ? `/static/${this.client_name}/images/header/logo_m.png` : `/static/${this.client_name}/images/header/logo.png`
            }
        },

        created() {
            this.do_short_term_precp_job();
        },

        destroyed() {
            clearInterval(this.short_term_precp_interval)
        },

        methods: {
            ...mapMutations([
                'set_short_term_precp_occur'
            ]),

            reset_alert_message() {
                this.show_alert_message = false;
            },

            do_short_term_precp_job() {
                if(!this.is_activate_short_term_precp_feature) return
                
                this.get_short_term_precp_status();
                this.short_term_precp_interval = setInterval(() => {
                    this.get_short_term_precp_status();
                }, 60000)
            },

            async get_short_term_precp_status() {
                const datetime_res = await get_short_term_precp_datetime_ajax(this.client_name)
                const newest_precp_datetime = datetime_res.data.data[1]
                if (this.newest_precp_datetime !== newest_precp_datetime) {
                    this.newest_precp_datetime = newest_precp_datetime
                    const is_occur_res = await get_short_term_precp_ajax(this.client_name, this.newest_precp_datetime)
                    this.set_short_term_precp_occur(is_occur_res.data.status === "success")
                }
            },

            show_short_term_precp_message() {
                this.is_show_short_term_precp_hint = true
            },

            hide_short_term_precp_message() {
                this.is_show_short_term_precp_hint = false
            }
        },
    };
</script>
